import _construct from "/home/ubuntu/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/construct";
import chroma from '../../chroma.js';
import Color from '../../Color.js';
import input from '../input.js';
import { unpack, type } from '../../utils/index.js';
import cmyk2rgb from './cmyk2rgb.js';
import rgb2cmyk from './rgb2cmyk.js';
Color.prototype.cmyk = function () {
  return rgb2cmyk(this._rgb);
};
var cmyk = function cmyk() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return _construct(Color, args.concat(['cmyk']));
};
Object.assign(chroma, {
  cmyk: cmyk
});
input.format.cmyk = cmyk2rgb;
input.autodetect.push({
  p: 2,
  test: function test() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    args = unpack(args, 'cmyk');
    if (type(args) === 'array' && args.length === 4) {
      return 'cmyk';
    }
  }
});
export { cmyk };